import React, { useCallback, useState } from 'react';

import { EmojiPicker } from 'Shared/components/EmojiMartComponents';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';
import { usePopover, WpPopoverOverlay } from 'Wpds/components/popover';
import './SidePanelTextEditorEmojiPicker.scss';

type Props = {
  onEmojiAdd: Function;
};

function SidePanelTextEditorEmojiPicker({ onEmojiAdd }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const popover = usePopover({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'top',
    showArrow: false,
    withBoxShadow: true,
    withStyling: false,
    withPadding: false,
  });

  const handleToggle = useCallback(() => setIsOpen(prevState => !prevState), []);

  const handleEmojiClick = useCallback(
    gif => {
      setIsOpen(false);
      onEmojiAdd(gif);
    },
    [onEmojiAdd]
  );

  return (
    <>
      <WpTooltip>
        <WpTooltipTrigger>
          <WpButton variant="tertiary" size="sm" ref={popover.targetRef} onClick={handleToggle}>
            <WpIcon name="smile" />
          </WpButton>
        </WpTooltipTrigger>
        {!isOpen && <WpTooltipContent>Add emoji</WpTooltipContent>}
      </WpTooltip>
      <WpPopoverOverlay context={popover}>
        <EmojiPicker onSelect={handleEmojiClick} title="Pick your emoji…" emoji="point_up" />
      </WpPopoverOverlay>
    </>
  );
}

export default SidePanelTextEditorEmojiPicker;
